import { 
    LOAD_TOOLTIP_DATA_IN_PROGRESS,
    LOAD_TOOLTIP_DATA_SUCCESS,
    LOAD_TOOLTIP_DATA_FAILURE,
    TOOLTIP_OPERATION_COMPLETED,
    OPEN_TOOLTIP_DIALOG,
    CLOSE_TOOLTIP_DIALOG,
    LOAD_LAST_EVENT_ID,
    LOAD_EVENT_TOOLTIP_DATA,
    CLEAR_EDIT_DATA
    // LOAD_UPLOAD_IMAGE_DATA,
    // LOAD_EMPTY_UPLOAD_IMAGE_DATA
  } from "./actions";
  
    const initialState = { isLoading: false, toolTipData: [], lastEventId:'',eventTooltipData:[]};
  
    export const tooltips = (state = initialState, action) => {
        const { type, payload } = action;
        switch (type) {
            case LOAD_TOOLTIP_DATA_SUCCESS: {
                const { data } = payload;
                return {
                    ...state,
                    isLoading: false,
                    toolTipData: data,
                };
            }     
            case LOAD_TOOLTIP_DATA_IN_PROGRESS:
            return {
                ...state,
                isLoading: true,
            };
            case LOAD_TOOLTIP_DATA_FAILURE:
            return {
                ...state,
                isLoading: false,
            };

            case OPEN_TOOLTIP_DIALOG:
            return {
                ...state,
                isTooltipDialogOpen: true,
            }; 
    
            case CLOSE_TOOLTIP_DIALOG:
            return {
                ...state,
                isTooltipDialogOpen: false,
            }; 
    

            case TOOLTIP_OPERATION_COMPLETED:
            return {
                ...state,
                isLoading: false,
            }; 

            case LOAD_LAST_EVENT_ID:{
                const { data } = payload;
                return {
                    ...state,
                    isLoading: false,
                    lastEventId : data
                }
            }

            case LOAD_EVENT_TOOLTIP_DATA:{
                const { data } = payload;
                return {
                    ...state,
                    isLoading: false,
                    eventTooltipData : data,
                }
            }

            case CLEAR_EDIT_DATA:{
                return {
                    ...state,
                    isLoading: false,
                    eventTooltipData : [],
                }
            }
            
            default:
                return state;
        }
    };
  